import { render, staticRenderFns } from "./ModalNoticia.vue?vue&type=template&id=5d06bd2d&"
import script from "./ModalNoticia.vue?vue&type=script&lang=js&"
export * from "./ModalNoticia.vue?vue&type=script&lang=js&"
import style0 from "./ModalNoticia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports